// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_cqElo","news":"index_news_fXs3K","text":"index_text_AST-F"};